export default __webpack_public_path__ + "static/walmart-1e57bee62b6689f2ed8f87c20eed4e46.webp";